var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLniLniCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8385 2.6615C13.6232 2.44617 13.2882 2.44617 13.0729 2.6615L4.93792 10.5572L0.918303 6.60934C0.702966 6.394 0.367998 6.41793 0.152662 6.60934C-0.0626748 6.82468 -0.0387485 7.15964 0.152662 7.37498L4.38761 11.4903C4.53117 11.6339 4.72258 11.7056 4.93792 11.7056C5.15326 11.7056 5.32074 11.6339 5.48822 11.4903L13.8385 3.37929C14.0538 3.21181 14.0538 2.87684 13.8385 2.6615Z",
    fill: "#72AE8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLniLniCheckmark);
export default __webpack_public_path__ + "static/media/lni_lni-checkmark.f4071bb881af03d942b3c384e9405b85.svg";
export { ForwardRef as ReactComponent };